import React, {Component} from 'react';
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {InputGroupAddon, Tooltip, Button} from "reactstrap";
import classnames from "classnames";
import InputRange from "react-input-range";

class SettingSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      value: props.value,
    };

    this.toggleTooltip = this.toggleTooltip.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  toggleTooltip() {
    this.setState({
      tooltip: !this.state.tooltip
    })
  }

  onChange(value){
    this.setState({
        value
      },() => this.props.handleUpdate({
        [this.props.name]: this.state.value
      })
    );
  }

  render() {
    const {tooltip, value} = this.state;
    const {id} = this.props.question;

    return (
      <React.Fragment>
        <div
          id={this.props.name + id}
          className={classnames({
            "min-w-0 float-left mr-1 mb-1 w-100 w-lg-auto input-group": true,
          })}
        >
          <InputGroupAddon addonType="prepend">
            <Button
              className={classnames({
                "btn-icon active": true,
              })}
              color="secondary"
            >
              <i className="fa-solid fa-arrows-left-right-to-line"/>
              <Tooltip
                delay={0}
                placement="top"
                isOpen={tooltip}
                target={this.props.name + id}
                toggle={this.toggleTooltip}
              >
                {this.props.tooltipText}
              </Tooltip>
            </Button>
          </InputGroupAddon>
          <div className="input-number-wrap pt-3 pt-md-1 overflow-hidden" style={{flex: '1 1 auto', minWidth: 150}}>
            <InputRange
              minValue={this.props.minValue}
              maxValue={this.props.maxValue}
              value={value}
              onChange={value => this.setState({value})}
              onChangeComplete={this.onChange}
              formatLabel={() => ""}
            />
          </div>
        </div>
      </React.Fragment>
    )
  }
}

SettingSlider.defaultProps = {
  minValue: 1,
  maxValue: 99,
};

SettingSlider.propTypes = {
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  value: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  handleUpdate: PropTypes.func.isRequired
};

export default SettingSlider;
